
class FbdClassTimeReadout {
   timestamp;
   eGui;

   init(params) {
      this.timestamp = params.value;

      const friendlyTime =  new Date(this.timestamp).toLocaleString();

      this.eGui = document.createElement('span');

      const timeLabel = document.createElement('span');
      timeLabel.innerText = friendlyTime;

      this.eGui.appendChild(timeLabel);
   }

   getGui() {
      return this.eGui;
   }

   refresh(params) {
      return false;
   }

   destroy() {

   }
}

export default FbdClassTimeReadout;